// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const GL_PHARMA_FIELD_ALIASES = {
  hospitalName: ['처방처명'],
  pharmaceuticalCompanyName: ['제약사명'],
  drugName: ['제품명'],
  unitPrice: ['약가'],
  quantity: ['수량'],
  prescriptionAmount: ['처방금액'],
  settlementAmount: ['정산금액'],
  feeRate: ['수수료(%)'],
  note: ['비고'],
};

const REQUIRED_HEADERS = [
  'No',
  '처방월',
  '거래처명',
  '처방처명',
  '제약사명',
  '제품명',
  '약가',
  '수량',
  '처방금액',
  '정산금액',
  '수수료(%)',
  '비고',
];

function isGlPharmaProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const glPharmaTemplate = {
  id: 'gl-pharma',
  name: '지엘파마 템플릿',
  match(context) {
    return context.headerProfiles.some(isGlPharmaProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isGlPharmaProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(GL_PHARMA_FIELD_ALIASES),
    );
    const extractedRows = [];

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const drugName = cleanText(row[columnMap.drugName]);
      if (!drugName) {
        return;
      }

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany: cleanText(
          row[columnMap.pharmaceuticalCompanyName],
        ),
        customerName: row[columnMap.hospitalName],
        drugName,
        unitPriceValue: row[columnMap.unitPrice],
        quantityValue: row[columnMap.quantity],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        feeRateValue: row[columnMap.feeRate],
        settlementAmountValue: row[columnMap.settlementAmount],
        note: row[columnMap.note],
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: '지엘파마',
      templateName: this.name,
    };
  },
};

export default glPharmaTemplate;
